<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="1200"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <AwsSku :disabled="disabled" :amzSkuCode="amzSkuCode" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import AwsSku from '@/views/ecom/base/awsGoods/components/aws-sku'
export default {
  mixins: [EditLoading],
  components: { AwsSku },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    type: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
    applicationStatus: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        detail: this.$l('dialog_title_detail') || '查看详情',
        edit: this.$l('dialog_title_edit') || '编辑产品',
      },
      formData: {},
      rules: {
        rejectReason: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    title() {
      return this.titleMap[`${this.type}`]
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    handleClose(done) {
      if (!['edit'].includes(this.type)) return done()
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => done())
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 10px 12px;
}

::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
